import { useMemo } from "react";
import { Badge, Card } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import "./DetailFeatures.css";
import { groupFeatures } from "./detailProperty.helpers";

const DetailFeatures = ({ features = [] }) => {
  const grouped = useMemo(() => groupFeatures(features), [features]);

  if (!grouped.length) return null;

  return (
    <Card className="detail-card">
      <Card.Body className="detail-card-body">
        <h3 className="section-title">Fitur & Keunggulan</h3>

        <div className="detail-feature-groups">
          {grouped.map((group) => (
            <div className="detail-feature-group" key={group.name}>
              <div className="detail-subtitle">{group.name}</div>

              <div className="detail-feature-chip-grid">
                {group.items.map((feature) => (
                  <Badge
                    key={feature.id || feature.code || feature.name}
                    className="detail-feature-chip"
                    bg="light"
                    text="dark"
                  >
                    <FaCheck />
                    <span>{feature.name || feature.label || "-"}</span>
                  </Badge>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default DetailFeatures;
